import Accordion from '../../../../shared/Accordion';

const Credentials = ({
  open,
  onToggle,
  editable,
  formDataUser,
  handleChange,
  acceptedPolicy,
  validPolicy,
  loading,
  privacyUrl,
  privacyLabel,
}) => {
  return (
    <div>
      <Accordion
        id="credenciales-acceso"
        title="Credenciales de acceso"
        open={open}
        onToggle={onToggle}
        edit={editable}
      >
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-1">
              Contraseña<span className="text-red-700"> *</span>
            </label>
            <input
              type="password"
              name="password"
              value={formDataUser.password}
              onChange={handleChange}
              className="w-full px-3 py-2 border border-gray-300 rounded text-sm"
              required
              readOnly
              disabled={loading}
              onFocus={(e) => (e.target.readOnly = false)}
            />
          </div>
          <div>
            <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-1">
              Confirmar Contraseña<span className="text-red-700"> *</span>
            </label>
            <input
              type="password"
              name="confirmPassword"
              value={formDataUser.confirmPassword}
              onChange={handleChange}
              className="w-full px-3 py-2 border border-gray-300 rounded text-sm"
              required
              readOnly
              disabled={loading}
              onFocus={(e) => (e.target.readOnly = false)}
            />
          </div>
        </div>
      </Accordion>
      <div className="flex items-start mt-4 mb-4">
        <input
          id="dataTreatment"
          type="checkbox"
          checked={acceptedPolicy}
          onChange={validPolicy}
          className="h-5 w-5  accent-personalized border-gray-300 rounded cursor-pointer"
          disabled={loading}
          required
        />
        <div className="ml-2 text-xs sm:text-sm text-gray-700 select-none">
          He leído y acepto la{' '}
          <a
            href={privacyUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="text-personalized no-underline hover:underline"
          >
            {privacyLabel}
          </a>
        </div>
      </div>
    </div>
  );
};

export default Credentials;
